import { render } from "./exerciseDialog.vue?vue&type=template&id=394ca900&scoped=true"
import script from "./exerciseDialog.vue?vue&type=script&lang=js"
export * from "./exerciseDialog.vue?vue&type=script&lang=js"

import "./exerciseDialog.vue?vue&type=style&index=0&id=394ca900&lang=scss&scoped=true"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394ca900"]])

export default __exports__